<template>
  <div class="roof" :style="{ width: roofWidth + 'px' }">
    <div class="upper-roof" />
    <div class="mid-roof" />
    <div class="lower-roof" />
  </div>
</template>

<script>
  export default {
    name: "Roof",

    props: {
      roofWidth: {
        type: Number,
        required: true
      }
    }
  }
</script>

<style>
.upper-roof {
  height: 12px;
  background: linear-gradient(to right,
      #e3e3e3 calc(100% - 35px),
      #d4d4d4 calc(100% - 35px) 100%);
}

.mid-roof {
  height: 4px;
  background-color: #c8c8c8;
  background: linear-gradient(to right,
      #c8c8c8 calc(100% - 35px),
      #9a9a9a calc(100% - 35px) 100%);
}

.lower-roof {
  height: 9px;
  background: linear-gradient(to right,
      #e3e3e3 calc(100% - 35px),
      #d4d4d4 calc(100% - 35px) 100%);
  border-bottom: 2px solid #afafaf;
}

.roof {
  margin-left: 36px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/BuildingComponents/Roof.vue